module.exports = __webpack_public_path__ + "static/media/hero-img.41560068.png";